import * as React from "react";
import { clsx } from "clsx";
import { CardContent } from "../../../card/card-content/card-content.mjs";
const OptionCardContent = (props) => {
  const { className, tagTop = true, ...rest } = props;
  return /* @__PURE__ */ React.createElement(
    CardContent,
    {
      ...rest,
      className: clsx(
        "option-card__content",
        {
          ["option-card__content--".concat(props.color)]: !!props.color
        },
        className
      ),
      tagTop
    },
    props.children
  );
};
export {
  OptionCardContent
};
